import React from 'react';
import { Permissioned } from 'react-permissions';
import {connect}  from 'react-redux';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import TransactionAPI from '../../../api/TransactionsApi';
import Util from '../../../util/util';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import NewClaimTxnFilter from './newClaimTxnFilter';
import NewClaimTxnTable from './newClaimTxnTable';
import NewClaimModal from './newClaimModal';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';


class NewClaimPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            tableData: [],
            selectedTransaction: null,
            loading: false
        }
        this.onSearchHandler = this.onSearchHandler.bind(this);
        this.onTransactionRowClick = this.onTransactionRowClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    onSearchHandler(txnType,channel, params) {
        this.setState({ loading: true, tableData : [] });

        TransactionAPI.findTransactions(txnType, channel, params)
            .then((response) => {
                let data = response.data;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Transactions")

                this.setState({ tableData: data, loading: false });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_TRANSACTIONS_SEARCH} - ${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_TRANSACTIONS_SEARCH_TITLE} - ${error.status}`);
                this.setState({ loading: false });
            });
    }
    onTransactionRowClick(index) {
        this.setState({ selectedTransaction: this.state.tableData[index] });
    }
    handleCloseModal() {
        this.setState({ selectedTransaction: null });
    }

    render() {
        return (
            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Search Transactions" />
                <NewClaimTxnFilter onSearchHandler={this.onSearchHandler} />
                <Divider />
                <NewClaimTxnTable
                    onRowClick={this.onTransactionRowClick}
                    tableData={this.state.tableData}
                    loading={this.state.loading} />
                {
                    this.state.selectedTransaction &&
                    <NewClaimModal
                        onRequestClose={this.handleCloseModal}
                        isOpen={this.state.selectedTransaction != null}
                        transaction={this.state.selectedTransaction} />
                }
            </div>
        );
    }
}

export default connect(Util.defaultMapStateToProps)(Permissioned(NewClaimPage, [Permissions.CREATE_DISPUTE]));


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimPage.js